export default __webpack_public_path__ + "static/media/Vest of the Bloodhunter (nm).336649bd.jpg";